
  import { defineComponent, PropType } from 'vue';
  import { mapActions } from 'vuex';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import { getSecToMs } from '@/common/utils/times';

  import { CALCULATION_COMMON_ACTIONS_NAME } from '../../store/calculationCommon/name';
  import { UploadingDataStatusTypes } from '../../types/calculation-common';
  import CalculationStatesLog from './CalculationStatesLog.vue';

  export default defineComponent({
    name: 'CalculationPageWrapper',
    props: {
      title: {
        type: String,
        required: true,
      },
      type: {
        type: Number as PropType<UploadingDataStatusTypes>,
        required: true,
      },
      isUploadingFile: {
        type: Boolean,
      },
      isShowLog: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      CalculationStatesLog,
      PageTitle,
    },
    data(): {
      intervalId?: number;
    } {
      return {
        intervalId: undefined,
      };
    },
    created() {
      this.searchUploadingDataStatus();
      this.intervalId = setInterval(this.searchUploadingDataStatus, getSecToMs(10));
    },
    beforeUnmount() {
      clearInterval(this.intervalId);
    },
    methods: {
      ...mapActions({
        searchUploadingDataStatus: CALCULATION_COMMON_ACTIONS_NAME.searchUploadingDataStatus,
      }),
    },
  });
